import '../../../external/typeahead/typeahead.bundle.js';

// Like bloodhoundAdapter but for typeahead-jquery. Basically: an abstraction over typeahead-jquery that's here so we
// can 1. swap typeahead-version without having to update every JS file that uses it 2. sham this out serverside.

// typeahead is automatically added to jquery, but also export Bloodhound for scripts that want it
export default window.Bloodhound;
